export default {
  namespaced: true,
  pbx_ip_block: {
    title: "IP Blocking",
    ip: "IP address",
    ban_ip: "Block an IP",
    ip_placeholder: "E.g. x.x.x.x",
    ban: "Block",
    unban: "Unblock",
    unban_selected: "Unblock selected",
    empty: "There are no blocked IP addresses",
    loading: "Loading IP addresses...",
    messages: {
      ban_success: "IP {ip} was blocked successfully",
      unban_success: "IP {ip} was unblocked successfully",
      bulk_success: "{count} IP addresses were unblocked",
      bulk_error: "Unable to unblock {count} IP addresses",
    },
  },
};
